import { CSSObject } from "@emotion/react";

export const featureButtonCss: CSSObject = {
  padding: "8px",
  justifyContent: "center",
  width: "100%",
};
